import PropTypes from "prop-types";
import { Select, MenuItem } from "@mui/material";

// Dropdown for editing status column
const statusOptions = [
  { value: "received", label: "Received" },
  { value: "pending", label: "Pending" },
  { value: "processing", label: "Processing" },
  { value: "paymentPending", label: "Payment Pending" },
  { value: "delivering", label: "Delivering" },
  { value: "delivered", label: "Delivered" },
  { value: "cancelled", label: "Cancelled" },
];

const StatusDropdown = ({ value = "received", onChange = () => {} }) => (
  <Select
    value={value || "received"}
    onChange={(e) => onChange(e.target.value)}
    fullWidth
    variant="standard"
  >
    {statusOptions.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ))}
  </Select>
);

StatusDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default StatusDropdown;
